module.exports = __webpack_public_path__ + "img/James Hillson.a7452df4.png";